import React, { useCallback, useRef, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Button, Menu, MenuItem } from '@mui/material';
import { actions } from '../PatientView.redux';
import DeletePopover from 'components/DeletePopover';
import { useNavigate, useParams } from '@tanstack/react-router';

const PatientReportsCell = (params) => {
    const { row, field } = params;
    const { patient_id } = useParams({ from: '/patients/view/$patient_id' });
    const id = row.urpt_id;
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const actionAnchor = useRef(null);
    const [actionsOpen, setActionsOpen] = useState(false);

    const beforeDeleteReport = useCallback(() => {
        dispatch(actions.setState({ loading: true }));
    }, [dispatch]);

    const afterDeleteReport = useCallback(() => {
        dispatch(actions.loadReports(patient_id));
        setActionsOpen(false);
    }, [dispatch, patient_id]);

    const handleNavigate = useCallback(() => {
        navigate({ to: `/reports/edit/${id}` });
    }, [navigate, id]);

    if (field === 'actions') {
        return (
            <>
                <Button
                    variant="outlined"
                    size="small"
                    onClick={(event) => {
                        event.stopPropagation();
                        setActionsOpen(true);
                    }}
                    ref={actionAnchor}
                >
                    ...
                </Button>
                <Menu open={actionsOpen} onClose={() => setActionsOpen(false)} anchorEl={actionAnchor.current}>
                    <MenuItem onClick={(event) => event.stopPropagation()}>
                        <DeletePopover
                            objectType="REPORT"
                            objectID={id}
                            afterDelete={afterDeleteReport}
                            beforeDelete={beforeDeleteReport}
                        >
                            <Button variant="text" size="large" color="error">
                                Delete Report
                            </Button>
                        </DeletePopover>
                    </MenuItem>
                </Menu>
            </>
        );
    }

    return <span onClick={handleNavigate}>{params.value ?? ''}</span>;
};

export default PatientReportsCell;
